<template>
  <div id="app" :key="recargar">
    <div id="skip">
        <a class="skip-main" href="#contenidoPrincipal"> {{ $t('contenido_principal') }}</a>
    </div>
    <!-- HEADER -->
    <div style="height:50px;">
      <!-- <fwjsHeader v-bind:title="$t('secretaria_virtual', {nombreApp: getNombreApp})" :isLogged="isLogged" style="z-index:9" @hamburgerClick="mueveMenu()" :hasWidget="false"/> -->

			<header class="fwjsheader" style="z-index: 9;">
				<span @click="logout()" class="enlace-blanco">
          <span class="fwjsheader__arrow">
              <i class="fas fa-long-arrow-alt-left"></i>
          </span>
				</span>
				<h1 class="fwjsheader__title"> {{$t('secretaria_virtual', {nombreApp: getNombreApp})}} </h1>
				<h2 class="fwjsheader__subtitle">  </h2>
			</header>

    </div>

    <div class="languages">
          <span class="userconected">
            <span>
              {{ $t('estudiante') }}: {{getNombreEstudiante}} 
              <!-- {{getEmailEstudiante}} -->
            </span> 
            <span v-if="isAdmin">
              (Suplantado por:&nbsp; {{getEmailSuplanta}})
            </span>
          </span>  

          <Button v-bind:class="claseEsp" @click="cambiaIdioma('es')" v-tooltip.botton="$t('castellano')" aria-label="castellano" />
          <Button v-bind:class="claseEng" @click="cambiaIdioma('en')" v-tooltip.botton="$t('english')"  aria-label="english"/>
    </div>

    <div id="contenido" v-bind:class="{ 'reveal': isReveal}" v-if="isLogged"> 
      <!-- MENÚ LATERAL -->
      <!-- <div v-bind:class="{ 'menu-lateral reveal': isReveal, 'menu-lateral': !isReveal }">
        <Menu :model="menuItems"/>
      </div> -->

      <!-- CONTENIDO -->
      <div>
        <router-view></router-view>
      </div>
    </div>

    <div v-if="!isLogged"> 
        <router-view></router-view>
    </div>

    <form id="formuCursos" name="formuCursos" method="post">
        <input type="hidden" name="token" v-model="getToken">
        <input type="hidden" name="uni_codigo" v-model="getUniCodigo">
    </form>    

    <footer>
       <div v-if="isLogged && getUniCodigo=='CA'" >  
        <span><a href="https://casiopea.um.es" target="_blank">Casiopea</a></span>
        <span><a href="mailto:estudiospropios@um.es">{{$t('contactar')}}</a></span>
        <span><a href="#" @click="abreDeclaracion()">{{$t('accesibilidad')}}</a></span>
      </div>
      <div v-if="getUniCodigo!='CA'" >  
        <span><a href="#" @click="abreDeclaracion()">{{$t('accesibilidad')}}</a></span>
      </div>
    </footer>
    <fwjsSessionModal @expired="logoutSession" />    
  </div>
</template>

<script>
import fwjsHeader from "@aulavirtual/fwjs-components/fwjsHeader";
import Menu from "primevue/menu";
import store from "./store"
import AuthRefresher from "@/mixins/AuthRefresher.js";
import fwjsSessionModal from "./components/fwjsSessionModal"

export default {
  components: {
    fwjsHeader,
    Menu,
    fwjsSessionModal,
  },
  data() {
    return {
      isReveal : this.$isMobile(),
      claseEng: "idioma_I001_d",
      claseEsp: "idioma_I017",
      recargar: 0,
      //isLogged : false,
      //isAdmin : false,
    };
  },
  computed: {
      // Accedemos al getter poniendo especificando el módulo / getter
      isLogged: function() {
        //console.log('IsLogged = ' + store.getters["token/isLogged"]);
        return store.getters["token/isLogged"];
      },
      isAdmin: function() {
        //let admin = this.$store.getters["token/isAdmin"];
        return store.getters["token/isAdmin"];
      },
      getNombreEstudiante: function() {
        return store.getters["token/getNombreEstudiante"];
      },
      getEmailEstudiante: function() {
        return store.getters["token/getEmailEstudiante"];
      },
      getEmailSuplanta: function() {
        return store.getters["token/getEmailSuplanta"];
      },
      getUniCodigo: function() {
        return store.getters["token/getUniCodigo"];
      },
      getToken: function() {
        return store.getters["token/getToken"];
      },
      getNombreApp: function() {
        return store.getters["token/nombreApp"];
      },
      getEmailApp: function() {
        return store.getters["token/emailApp"];
      },
      getUrlLoginServicios: function() {
        return store.getters["token/urlLoginServicios"];
      },
      getTelefonoApp: function() {
        return store.getters["token/telefonoApp"];
      },
      getTextoDiploma: function() {
        return store.getters["token/textoDiploma"];
      },
      getTextoDiplomas: function() {
        return store.getters["token/textoDiplomas"];
      },
      getTextoDiplomasCap: function() {
        return store.getters["token/textoDiplomasCap"];
      },
  },  
  created () {
    this.cargarMenu();
  },
  methods: {
    cargarMenu () {
      this.menuItems = [
          {
          label:this.$t('secretaria'),    
          items: [
            {
              label: this.$t('menu_inicio'),              
              icon: "pi pi-star",
              command: () => {
                this.menuDefecto();
                this.$router.push({ name: "Bienvenido" });
              },
            },
            {
              label: this.$t('menu_solicitardiploma', {textoDiploma: this.getTextoDiploma }),            
              icon: "pi pi-fw pi-cloud",
              command: () => {
                this.menuDefecto();
                this.$router.push({ name: "SolicitarDiploma" });
              },
            },
            {
              label: this.getTextoDiplomas, 
              icon: "pi pi-fw  pi-list",
              command: () => {
                this.menuDefecto();
                this.$router.push({ name: "Diplomas" });
              },
            },
            {
              label: this.$t('menu_salir'), 
              icon: "pi pi-fw  pi-logout",
              command: () => {
                this.logout();
              },
            },
          ],
        },    
      ];
    },
    mueveMenu() {
      this.isReveal = !this.isReveal;
    },
    menuDefecto() {
      this.isReveal = this.$isMobile();
    },
    logout() {
      let urlLoginServicios =  store.getters["token/urlLoginServicios"];
      var f = document.forms["formuCursos"];
      f.action = urlLoginServicios;
      this.$store.dispatch("token/revokeToken");
      this.$store.dispatch("token/revokeAdmin");
      this.$store.dispatch("token/revokeNombreEstudiante");
      this.$store.dispatch("token/revokeEmailEstudiante");
      this.$store.dispatch("token/revokeEmailSuplanta");
      this.$store.dispatch("token/revokeUniCodigo");
      f.submit();

      //location.href=urlLoginServicios;
    },
    logoutSession: function() {
      let urlLogin =  store.getters["token/urlLogin"];
      var f = document.forms["formuCursos"];
      f.action = urlLogin;
      this.$store.dispatch("token/revokeToken");
      this.$store.dispatch("token/revokeAdmin");
      this.$store.dispatch("token/revokeNombreEstudiante");
      this.$store.dispatch("token/revokeEmailEstudiante");
      this.$store.dispatch("token/revokeEmailSuplanta");
      this.$store.dispatch("token/revokeUniCodigo");
      f.submit();

      //location.href=urlLogin;
    },
    cambiaIdioma(idioma) {
        //tambien cambiamos las clases de las banderas
        if (idioma === "en") {
          this.$i18n.locale = "en";
          this.claseEsp = "idioma_I017_d";
          this.claseEng = "idioma_I001";
        } else {
          this.$i18n.locale = "es";      
          this.claseEsp = "idioma_I017";
          this.claseEng = "idioma_I001_d";
        }
        this.recargar++;
        this.cargarMenu();
    },
    abreDeclaracion(){
      this.$router.push({ name: 'DeclaracionAccesibilidad'})
    },
  },
  mixins:[
    AuthRefresher
  ]

};


</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}



</style>
